import React from 'react'
import { withTranslationCustom } from 'lib/i18next'
import { withRouter } from 'react-router-dom'
import { flowRight } from 'lodash'

import ErrorMessageContent from './ErrorMessageContent'

import 'styles/status-message.pcss'

const EntityNotFoundMessage = ({ t, appError }) => {
    const data = appError.data

    const { entity } = data

    let message = t('errors:omanettix.10008.message')

    // try to read the entity not found message by entity type
    if (entity && entity.type) {
        message = t([`errors:omanettix.10008.${entity.type}.message`, 'errors:omanettix.10008.message'])
    }

    return (
        <ErrorMessageContent
            content={<p>{message}</p>}
        />
    )
}

export default flowRight(
    withRouter,
    withTranslationCustom(['errors', 'formElements'])
)(EntityNotFoundMessage)
